class Blacklist {
  constructor() {
    this.lists      = [];
    this.referrer   = document.referrer;
    this.urlSearch  = window.location.search;
  }

  async start() {
    const safeAccess = JSON.parse(sessionStorage.getItem('safeAccess'));
    if (safeAccess === false) {
      console.log('bl - not safe access');
      return false;
    } 

    this.lists = null;

    const valid = this.validate();
    sessionStorage.setItem('safeAccess', valid);
    console.log(`[Visitor Guard] access is ${valid ? 'safe' : 'NOT safe'}`);

    return valid;
  }

  
  validate() {
    if (!this.lists || !this.lists.domains || !this.lists.strings) return true;

    const blockedDomain = this.lists.domains
      .map(d => d.domain)
      .find(domain => this.referrer.includes(domain));

    const blockedString = this.lists.strings
      .map(s => s.string)
      .find(string => this.urlSearch.includes(string));

    return !(blockedDomain || blockedString);
  }
}

window.blacklist = new Blacklist();
window.blacklist.start();

